import React from "react";

import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import { withRouter } from "react-router";
import { Button } from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

function Logout(props) {
  const { logoutOpen, handleLogoutClose } = props;
  const { request } = useApi();
  const auth = useAuth();

  const logout = () => {
    request({
      method: "GET",
      url: `authentication/logout`,
    })
      .then((data) => {
        handleLogoutClose(false);
        auth.logout();
        props.history.push("/");
      });
  };
  return (
    <Dialog open={logoutOpen} onClose={() => handleLogoutClose(false)}>
      <DialogContent>
        <DialogContentText>ログアウトしますか？</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={logout}>
          はい
        </Button>
        <Button color="primary" onClick={() => handleLogoutClose(false)}>
          いいえ
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default withRouter(Logout);
